import React from 'react';
import styled from '@emotion/styled';
import Number from '../../../../../../utils/number';
import Button from '../../../../../../components/button';

export const CardPlano = ({ plano, onClick, clickButton }) => {
  const { titulo, valorAnual, valorMensal, descricao, quantidadeAdicional, pessoaFisica, pessoaJuridica } =
    plano;
  const valorMensalWithCurrencyFormat = valorMensal
    ? Number.currencyFormat(valorMensal)
    : null;
  const valorAnualWithCurrencyFormat = valorAnual
    ? Number.currencyFormat(valorAnual)
    : null;

  return (
    <Card onClick={onClick}>
      <Row>
        <Title>{titulo}</Title>
      </Row>
      <ContainerDescricao>
        <DescricaoText>{descricao}</DescricaoText>
      </ContainerDescricao>
       {pessoaFisica && (
        <ContainerValor>
          <ValorValueStyle>Pessoa Física</ValorValueStyle>
        </ContainerValor>
      )}
      {pessoaJuridica && (
        <ContainerValor>
          <ValorValueStyle>Pessoa Jurídica</ValorValueStyle>
        </ContainerValor>
      )}
      {quantidadeAdicional && (
        <ContainerValor>
          <ValorTextStyle>Qtd de dependentes:</ValorTextStyle>
          <ValorValueStyle>{quantidadeAdicional}</ValorValueStyle>
        </ContainerValor>
      )}
      {valorMensalWithCurrencyFormat && (
        <ContainerValor>
          <ValorTextStyle>Valor mensal:</ValorTextStyle>
          <ValorValueStyle>{valorMensalWithCurrencyFormat}</ValorValueStyle>
        </ContainerValor>
      )}
      {valorAnualWithCurrencyFormat && (
        <ContainerValor>
          <ValorTextStyle>Valor Anual:</ValorTextStyle>
          <ValorValueStyle>{valorAnualWithCurrencyFormat}</ValorValueStyle>
        </ContainerValor>
      )}
      <ContainerButton onClick={clickButton}>
        <ProcedimentosButton variant="contained">
          Ver Procedimentos
        </ProcedimentosButton>
      </ContainerButton>
    </Card>
  );
};

const Card = styled.div`
  width: 280px;
  height: 300px;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;
const ProcedimentosButton = styled(Button)`
  text-align: center;
  width: 100%;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const ContainerValor = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  height: 25px;
`;

const ContainerDescricao = styled.div`
  flex: 1;
  overflow-y: auto;
`;
const ContainerButton = styled.div`
  width: 100%;
  margin-top: 15px;
`;
const Title = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 18px;
`;
const DescricaoText = styled.p`
  color: #09101d;
  font-size: 14px;
  font-weight: 500;
`;

const ValorTextStyle = styled.p`
  color: #09101d;
  font-size: 12px;
  font-weight: 500;
`;
const ValorValueStyle = styled.p`
  color: #09101d;
  font-size: 12px;
  font-weight: 700;
`;
